import Vue from 'vue'
import Vuex from 'vuex'
import user from './user'
import activity from './activity'

Vue.use(Vuex)

export default new Vuex.Store({
	namespaced: true,
	state: {
		showLoading:false
	},
	modules: {
		user,
		activity
	},
	mutations: {
		req (state,data) {
			state.showLoading = data;
		}
	}
})



// WEBPACK FOOTER //
// ./src/store/index.js